<script setup lang="ts">
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import type { Component } from 'vue'
import { faTriangleExclamation as faDuoTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons'
import { faCircleInfo, faSparkles, faTriangleExclamation } from '@fortawesome/pro-light-svg-icons'
import { badgeVariants } from '~/utils/badge'
import NewIcon from './icons/New.vue'

const props = defineProps<{
  variant: BadgeIntent
  size: BadgeSize
  label?: string
}>()

interface IconVariant {
  icon?: IconDefinition
  component?: never
}

interface ComponentVariant {
  component: Component
  icon?: never
}

const VARIANTS = {
  success: {
    icon: faSparkles,
  },
  warning: {
    icon: faTriangleExclamation,
  },
  danger: {
    icon: faDuoTriangleExclamation,
  },
  info: {
    icon: faCircleInfo,
  },
  neutral: {
    icon: undefined,
  },
  new: {
    component: NewIcon,
  },
} as const satisfies Record<BadgeIntent, IconVariant | ComponentVariant>

const v = computed(
  () =>
    VARIANTS[props.variant] as {
      icon?: IconDefinition
      component?: Component
    },
)
</script>

<template>
  <div
    :class="[badgeVariants({ intent: variant, size })]"
    :aria-label="label"
  >
    <Icon v-if="v.icon" :icon="v.icon" size="sm" />
    <component :is="v.component" v-else-if="v.component" />
    <span v-if="label">{{ label }}</span>
  </div>
</template>
